
export function isDev() {
  return process.env.NODE_ENV === 'development' ||
    (!!window.systemName && window.systemName === 'development')
}

export function getEnvironmentPrefix(systemName) {
  return systemName && systemName !== 'production' ? `${systemName}-` : ''
}

export function isServiceHealthy(serviceHealth) {
  return serviceHealth.responseCode === 200
}

export function isServiceUnhealthy(serviceHealth) {
  return serviceHealth.responseCode !== 200
}

export function isServiceRunningLocally(serviceHealth) {
  return !serviceHealth.usingRemote
}

export function isServiceRunningRemotely(serviceHealth) {
  return !!serviceHealth.usingRemote
}

export function getConsolidatedServiceHealth(serviceHealth) {
  return {
    services: [
      ...serviceHealth.services || [],
      getSuccessServiceHealth('frontend-service'),
      getSuccessServiceHealth('backend-service'),
    ],
  }
}

export function getServiceState(serviceHealth) {
  if (isServiceUnhealthy(serviceHealth))
    return 'error'

  if (isServiceRunningRemotely(serviceHealth))
    return 'remote'

  return 'local'
}

export function getSuccessServiceHealth(name) {
  return {
    "serviceName": name,
    "responseCode": 200,
    "usingRemote": false,
    "error": null,
    "useRemoteHint": "",
  }
}

export function sortServices(services) {
  const localServices = services.filter(isServiceHealthy).filter(isServiceRunningLocally)
  const remoteServices = services.filter(isServiceHealthy).filter(isServiceRunningRemotely)
  const errorServices = services.filter(isServiceUnhealthy)
  return [...errorServices, ...remoteServices, ...localServices]
}

export function getServicePoolWidth(services) {
  return Math.min(3, Math.max(8, Math.ceil(services.length / 4)))
}

export function createServicePool(services, poolWidth) {
  let currentRow = []
  const rows = [currentRow]

  for (let i = 0, row = 0, col = 0; i < services.length; i++) {
    const service = services[i]
    currentRow.push(service)

    const targetRowWidth = row % 2 === 0 ? poolWidth : poolWidth - 1
    if (col === targetRowWidth) {
      currentRow = []
      rows.push(currentRow)
      col = 0
      row++
    } else {
      col++
    }
  }

  return rows
}

export function getServiceLabel(name) {
  if (!name)
    return ''

  const words = name.split('-')
  return words[0].substring(0, 3).toUpperCase()
}